import { Ok } from '@core/model/framework/Result/OkResult';
import {
  AccountService,
  GetAccountsOutput,
  GetCaseStateServiceInput,
  GetCaseStateServiceOutput,
  RequestAnalysisServiceOutput,
  SynchronizeAccountsServiceOutput,
} from '@core/model/service/accountService';
import { injectable } from 'inversify';

@injectable()
export class IMAccountService implements AccountService {
  getAccounts(): GetAccountsOutput {
    throw new Error('Method not implemented.');
  }
  requestAnalysis(): RequestAnalysisServiceOutput {
    throw new Error('Method not implemented.');
  }
  synchronizeAccounts(): SynchronizeAccountsServiceOutput {
    throw new Error('Method not implemented.');
  }

  async getCaseState(input: GetCaseStateServiceInput): GetCaseStateServiceOutput {
    switch (input.userId) {
      case 'RETRY_ACCOUNT':
        return Ok('RETRY_ACCOUNT');
      case 'IN_PROGRESS':
        return Ok('IN_PROGRESS');
      case 'SUCCESS':
        return Ok('SUCCESS');
      case 'FAILED':
        return Ok('FAILED');
      case 'THROW':
      default:
        throw new Error('unexpected value');
    }
  }
}
